import {css} from "lit";

export const annotationOnDarkStyles = css`
  --_annotation-color: var(--sbkAnnotationFgColorOnDarkEnabled);
  --_annotation-color-error: var(--sbkAnnotationFgColorOnDarkError);
  --_annotation-color-disabled:var(--sbkAnnotationFgColorOnDarkDisabled);
`;
